import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Context
import { ThemeProvider } from "./context/ThemeContext";

// Components
import { Loader } from "./components/Loader";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

// Pages
import { Home } from "./pages/Home";
import { Products } from "./pages/Products";
import { ProductDetail } from "./pages/ProductDetail";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Catalogue } from "./pages/Catalogue";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Preload the logo image
    const img = new Image();
    img.src = 'https://customer-assets.emergentagent.com/job_4a46bb01-e425-48c8-a790-c185a7fd0b57/artifacts/6wdpibd5_logomedusa.jpeg';
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        {/* Animated Loader */}
        {isLoading && <Loader onLoadComplete={() => setIsLoading(false)} />}

        <BrowserRouter>
          {/* Navigation */}
          <Navbar />

          {/* Main Content */}
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/catalogue" element={<Catalogue />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>

          {/* Footer */}
          <Footer />

          {/* Floating WhatsApp Button */}
          <WhatsAppButton />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
